/**
 * Theme Provider Component
 *
 * Wraps the app with theme context and Ant Design ConfigProvider
 * Handles theme switching and initialization
 */

import { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import useThemeStore from '../store/themeStore';
import { lightTheme } from './lightTheme';
import { darkTheme } from './darkTheme';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const { resolvedTheme, initializeTheme } = useThemeStore();

  // Initialize theme on mount
  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  // Select theme config based on resolved theme
  const themeConfig = resolvedTheme === 'dark' ? darkTheme : lightTheme;

  return (
    <ConfigProvider theme={themeConfig}>
      {children}
    </ConfigProvider>
  );
}
